import React from 'react'

import { useAuthentication } from '../../hooks/useAuthentication'
import { useQuery } from '@apollo/react-hooks'
import { GET_DASHBOARD_SUMMARY } from './gql'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import HomeIcon from '@mui/icons-material/Home'
import Loader from '../Loader'
import PageHeader from '../Common/PageHeader'
import OversightView from './OversightView'
import PersonalView from './PersonalView'

const Dashboard = () => {
  const { authState } = useAuthentication()
  const result = useQuery(GET_DASHBOARD_SUMMARY, {
    context: { headers: { authorization: authState.authToken } },
    fetchPolicy: 'network-only',
  })

  if (result.loading && !result.data) return <Loader />
  if (result.error) return <p>Error: {result.error.message}</p>

  const summary = result.data?.dashboardSummary
  if (!summary) return <p>No data available</p>

  const isSingleDepartmentNational =
    summary.scope === 'NATIONAL' && !!summary.oversight?.is_single_department

  const subtitle = isSingleDepartmentNational
    ? `Your department, nationwide — every branch you're permitted to see.`
    : summary.scope === 'NATIONAL'
      ? "System-wide overview — every branch, every department you're permitted to see."
      : summary.scope === 'BRANCH'
        ? 'Your branch — every department you’re permitted to see.'
        : 'Your department, your branch, at a glance.'

  return (
    <Box sx={{ width: '100%' }}>
      <PageHeader title="Dashboard" icon={HomeIcon} />
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {subtitle}
      </Typography>

      {summary.oversight ? (
        <OversightView
          scope={summary.scope}
          awaitingMyApproval={summary.awaiting_my_approval}
          oversight={summary.oversight}
        />
      ) : (
        <PersonalView
          awaitingMyApproval={summary.awaiting_my_approval}
          personal={summary.personal}
        />
      )}
    </Box>
  )
}

export default Dashboard
